import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUiState } from 'redux/slices/uiSlice';

/**
 * Mirrors the user's navigation preferences from `userDetails.userSetting`
 * into ui state, which the sidebar, rail and top nav read.
 *
 * The backend is the source of truth (`twoLevelNavigation`,
 * `sidebarCollapsedByDefault`); ui state keeps a persisted copy so the nav
 * renders the right layout on reload before user details have loaded. A key
 * the backend has not set yet (not a boolean) leaves the local value alone.
 */
const useNavPreferencesSync = () => {
  const dispatch = useDispatch();
  const twoLevelNavigation = useSelector(
    (state) => state.userDetails.userDetails?.userSetting?.twoLevelNavigation,
  );
  const sidebarCollapsedByDefault = useSelector(
    (state) =>
      state.userDetails.userDetails?.userSetting?.sidebarCollapsedByDefault,
  );

  useEffect(() => {
    if (typeof twoLevelNavigation !== 'boolean') return;
    dispatch(updateUiState({ key: 'twoLevelNav', value: twoLevelNavigation }));
  }, [dispatch, twoLevelNavigation]);

  useEffect(() => {
    if (typeof sidebarCollapsedByDefault !== 'boolean') return;
    dispatch(
      updateUiState({
        key: 'navCollapsedByDefault',
        value: sidebarCollapsedByDefault,
      }),
    );
  }, [dispatch, sidebarCollapsedByDefault]);
};

export default useNavPreferencesSync;
